import { GetServerSideProps } from 'next'
import { routes } from '~/config/routes'
import {
  PageBySlugDocument,
  PageBySlugQuery,
  PageBySlugQueryVariables,
} from '~/graphql/page-by-slug'
import { withStripe } from '~/hocs/with-stripe'
import { initializeApollo } from '~/hooks/use-apollo'
import { FundraisingPageCheckout } from '~/pages/fundraising-page-checkout'
import { PageStatus } from '~/types/graphql'
import { isMissingPageError } from '~/utils/api-error'

type Props = {
  page?: PageBySlugQuery['pageBySlug']
  fundraiser?: PageBySlugQuery['pageBySlug']['fundraisers'][0]
}

export const getServerSideProps: GetServerSideProps<Props> = async context => {
  const apolloClient = initializeApollo()

  try {
    const { data } = await apolloClient.query<
      PageBySlugQuery,
      PageBySlugQueryVariables
    >({
      query: PageBySlugDocument,
      variables: {
        slug: context.query.slug as string,
      },
    })

    if (data!.pageBySlug.status !== PageStatus.Published) {
      context.res.setHeader(
        'Location',
        routes.fundraisingPage.home(data!.pageBySlug.slug!).as
      )
      context.res.statusCode = 307
      context.res.end()
      return {
        props: {},
      }
    }

    return {
      props: {
        page: data!.pageBySlug,
        hasDonations: data!.community.pageInfo.totalItems !== 0,
      },
    }
  } catch (error: any) {
    if (isMissingPageError(error)) {
      return { notFound: true }
    }

    throw error
  }
}

export default withStripe(FundraisingPageCheckout)
